import fp from 'lodash/fp';
import { adminActions } from '../../../../../state/modules/admin';
import { createDownloadBusinessActivityButton } from '../../../shared/create-download-business-activity-button';

const stateSelectors = ({ industry, publisher, admin }) => ({
  publishers: publisher.publishers,
  industriesWithCpdCategorys: fp.get('industriesWithCpdCategorys')(industry),
  isFetching: admin.isFetchingBusinessActivities,
  businessActivities: admin.businessActivities
});

export default createDownloadBusinessActivityButton({
  getBusinessActivities: adminActions.admin.getBusinessActivities,
  cleanBusinessActivities: adminActions.admin.cleanBusinessActivities,
  stateSelectors
});



// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/user-portal/partial/download-business-activity-button-for-admin.js